export const validatePassword = (p1: string, p2: string): string => {
  // Check length > 6
  if (p1.length < 6) {
    return 'Wachtwoord moet minstens 6 karakters bevatten';
  }

  if (p1 !== p2) {
    return 'Wachtwoorden komen niet overeen';
  }

  return '';
};
